const providers = ['garmin', 'strava', 'fitbit', 'polar', 'suunto', 'coros', 'underarmour', 'eventscom', 'concept2', 'asdeporte'];
const auto_redirect_providers = ['eventscom', 'asdeporte', 'coros', 'suunto', 'polar'];

import tenantConfig from '@/data/tenants.config.js';

export default {

    shouldAutoRedirect(provider) {
        return auto_redirect_providers.includes(provider);
    },
    getSupportedProviders() {
        return ['Garmin', 'Strava', 'Under Armour (MapMyRun, ...)', 'Fitbit', 'Polar', 'Suunto', 'COROS']
    },
    hasConnection(profile) {
        return profile && profile.providers && profile.providers.length > 0;
    },
    isConnected(profile, provider) {
        return profile && profile.providers && profile.providers.indexOf(provider) >= 0;
    },
    hasAllConnections(profile) {
        return providers.every(x => this.isConnected(profile, x));
    },

    getProviderUrls(options, event) {
        options = this.mergeOptions(options);
        return {
            strava: this.stravaConnectUrl('read,activity:read', options, event),
            strava_all: this.stravaConnectUrl('read,activity:read_all', options, event),
            garmin: this.garminConnectUrl(options),
            fitbit: this.fitbitConnectUrl(options),
            polar: this.polarConnectUrl(options),
            suunto: this.suuntoConnectUrl(options),
            coros: this.corosConnectUrl(options),
            underarmour: this.underarmourConnectUrl(options),
            eventscom: this.eventsComConnectUrl(options),
            concept2: this.concept2ConnectUrl(options),
            asdeporte: this.asdeporteConnectUrl(options),
        };
    },

    mergeOptions(options) {
        const tenant = tenantConfig.current();
        return {
            ...{
                tenant: tenant.id,
                referral: null,
                eventId: null,
                verificationCode: null,
                profileId: null,
                viewMode: null,
            },
            ...options,
        };
    },

    stravaConnectUrl(scope, options, event) {
        // try get from event.strava_app_id
        var clientId = process.env.VUE_APP_STRAVA_CLIENT_ID;
        var redirectUrl = process.env.VUE_APP_STRAVA_REDIRECT_URL;
        if (event && event.oauth_client_ids && event.oauth_client_ids.strava) {
            clientId = event.oauth_client_ids.strava;
            redirectUrl = "https://api.sodisp.com/open/v1.0/oauth/strava"; // must be from api.sodisp.com domain
        }
        return `http://www.strava.com/oauth/authorize?client_id=${clientId}&response_type=code&redirect_uri=${redirectUrl}&approval_prompt=auto&scope=${scope}&state=${encodeURIComponent(JSON.stringify(options))}`;
        //return `http://www.strava.com/oauth/authorize?client_id=${clientId}&response_type=code&redirect_uri=https://api.sodisp.com/open/v1.0/oauth/strava&approval_prompt=auto&scope=${scope}&state=${encodeURIComponent(JSON.stringify(options))}`;
    },
    garminConnectUrl(options) {
        return `${process.env.VUE_APP_GARMIN_CONNECT_URL}?tenant=${options.tenant}&referral=${options.referral || ''}&eventId=${options.eventId || ''}&verificationCode=${options.verificationCode || ''}&view=${options.viewMode || ''}&profileId=${options.profileId || ''}`;
    },
    fitbitConnectUrl(options) {
        return `https://www.fitbit.com/oauth2/authorize?client_id=${process.env.VUE_APP_FITBIT_CLIENT_ID}&response_type=code&redirect_uri=${process.env.VUE_APP_FITBIT_REDIRECT_URL}&scope=activity profile location&state=${encodeURIComponent(JSON.stringify(options))}`;
    },
    polarConnectUrl(options) {
        return `https://flow.polar.com/oauth2/authorization?client_id=${process.env.VUE_APP_POLAR_CLIENT_ID}&response_type=code&redirect_uri=${process.env.VUE_APP_POLAR_REDIRECT_URL}&scope=accesslink.read_all&state=${encodeURIComponent(JSON.stringify(options))}`;
    },
    suuntoConnectUrl(options) {
        return `https://cloudapi-oauth.suunto.com/oauth/authorize?client_id=${process.env.VUE_APP_SUUNTO_CLIENT_ID}&response_type=code&redirect_uri=${process.env.VUE_APP_SUUNTO_REDIRECT_URL}&state=${encodeURIComponent(JSON.stringify(options))}`;
    },
    underarmourConnectUrl(options) {
        return `https://api.mapmyfitness.com/v7.1/oauth2/authorize/?client_id=${process.env.VUE_APP_UNDERARMOUR_CLIENT_ID}&response_type=code&redirect_uri=${process.env.VUE_APP_UNDERARMOUR_REDIRECT_URL}&state=${encodeURIComponent(JSON.stringify(options))}`;
    },
    corosConnectUrl(options) {
        return `${process.env.VUE_APP_COROS_CONNECT_URL}?client_id=${process.env.VUE_APP_COROS_CLIENT_ID}&response_type=code&redirect_uri=${process.env.VUE_APP_COROS_REDIRECT_URL}&state=${encodeURIComponent(JSON.stringify(options))}`;
    },
    eventsComConnectUrl(options) {
        const scope = 'openid+profile+email+refreshToken';
        return `${process.env.VUE_APP_EVENTSCOM_CONNECT_URL}?client_id=${process.env.VUE_APP_EVENTSCOM_CLIENT_ID}&scope=${scope}&response_type=code&redirect_uri=${process.env.VUE_APP_EVENTSCOM_REDIRECT_URL}&state=${encodeURIComponent(JSON.stringify(options))}`;
    },
    concept2ConnectUrl(options) {
        const scope = 'user:read,results:read';
        return `${process.env.VUE_APP_CONCEPT2_CONNECT_URL}?client_id=${process.env.VUE_APP_CONCEPT2_CLIENT_ID}&scope=${scope}&response_type=code&redirect_uri=${process.env.VUE_APP_CONCEPT2_REDIRECT_URL}&state=${encodeURIComponent(JSON.stringify(options))}`;
    },
    asdeporteConnectUrl(options) {
        const scope = 'identity';
        return `${process.env.VUE_APP_ASDEPORTE_CONNECT_URL}?client_id=${process.env.VUE_APP_ASDEPORTE_CLIENT_ID}&scope=${scope}&redirect_to=${process.env.VUE_APP_ASDEPORTE_REDIRECT_URL}&state=${encodeURIComponent(JSON.stringify(options))}`;
    },
}
